import { AppEffects } from './app.effects';
import { ErrorEffects } from './error.effects';

export const rootEffects = [AppEffects, ErrorEffects];
